import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const NotFoundPageWrapper = styled(Row)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  padding: ${({ theme }) => theme.x4spacePx}px;
  text-align: center;
  h2,
  p {
    color: ${({ theme }) => theme.color.white};
  }
`;

export const SubHeading = styled('h3')`
  color: ${({ theme }) => theme.color.white};
`;

export const Links = styled('ul')`
  > li {
    padding: ${({ theme }) => theme.x1spacePx}px 0;
  }
`;
